import React from 'react';
import { ExternalLink } from 'lucide-react';

export const inputCls = 'mls-field w-full h-8 px-2 text-xs rounded-md border border-slate-200 bg-white text-slate-800 focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100 disabled:bg-slate-50 disabled:text-slate-400 read-only:bg-slate-50/80 read-only:text-slate-600 read-only:border-slate-200/80';
export const labelCls = 'block text-[10px] font-semibold text-slate-500 uppercase tracking-wider mb-1';

export const Field = ({ label, value, onChange, type = 'text', options, disabled, readOnly, placeholder, testId, className = '', icon: Icon, link, required = false }) => (
  <div className={className}>
    <label className={`${labelCls} flex items-center gap-1`}>{Icon && <Icon className="w-3 h-3 text-slate-400" />}{label}</label>
    {type === 'select' ? (
      <select value={value || ''} disabled={disabled || readOnly} onChange={(e) => onChange(e.target.value)}
        className={`${inputCls} ${readOnly && !disabled ? 'bg-slate-50/80 text-slate-600' : ''}`} data-testid={testId}>
        {!required && <option value="">—</option>}
        {options.map((o) => (Array.isArray(o) ? <option key={o[0]} value={o[0]}>{o[1]}</option> : <option key={o} value={o}>{o}</option>))}
      </select>
    ) : (
      <div className="relative">
        <input type={type} value={value || ''} disabled={disabled} readOnly={readOnly} placeholder={readOnly ? (placeholder && placeholder.startsWith('N/A') ? placeholder : '--') : placeholder}
          onChange={(e) => onChange(e.target.value)} className={`${inputCls} ${link && value ? 'pr-7' : ''}`} data-testid={testId} />
        {link && value && (
          <a href={/^https?:\/\//i.test(value) ? value : `https://${value}`} target="_blank" rel="noreferrer"
            className="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-blue-600 transition-colors" title="Open website"
            data-testid={`${testId}-open`}><ExternalLink className="w-3 h-3" /></a>
        )}
      </div>
    )}
  </div>
);
